import { useQuery } from "../_app/lib/query";
import { useAuthSession } from "../auth/hooks";
import { getEnabledFeatures } from "./api";
import { Feature } from "./types";

export function useEnabledFeatures(options = {}) {
  const { data: session } = useAuthSession();

  return useQuery({
    queryKey: ["enabledFeatures"],
    queryFn: () => getEnabledFeatures(),
    staleTime: 1000 * 60 * 15,
    enabled: Boolean(session?.userSub),
    ...options,
  });
}

export function useHasAnyFeatureEnabled(...features: Feature[]): boolean {
  const { data: enabledFeatures } = useEnabledFeatures();

  if (!enabledFeatures || !features) return false;

  if (features.length === 0) return true;

  return features.some((feature) => enabledFeatures.includes(feature));
}
